/**
 *
 * Event dispatcher base class
 *
 * Usage:
 * 1. Create class that inherits from EventDispatcher
 *
 * 2. Register all events from inside the component:
 *
 *      this.registerEvent('change');
 *
 * 3. Attach listeners from outside the component
 *
 *      object.on('change', function(){
 *          //Callback functionality goes here
 *      });
 *
 * 4. Dispatch events from inside the component
 *
 *      this.dispatchEvent('change', [args]);
 *
 * 5. To remove an event listener:
 *
 *      this.off('change', callbackFunction);
 *
 * @returns object EventDispatcher
 */
define([
    'jQuery',
    'library/fcse-compatibility/object'
],
    function ($, Object) {
        var Event = function (name) {
            this.name = name;
            this.callbacks = [];
        };

        Event.prototype.registerCallback = function (callback) {
            this.callbacks.push(callback);
        };

        var EventDispatcher = function () {
            /**
             * Internal store of all registered events
             */
            this._events = [];
        };

        EventDispatcher.prototype = $.extend({}, {
            /**
             * Register an event on the object to be able to listen to it and
             * dispatch it
             *
             * @param {type} eventName
             * @returns {undefined}
             */
            registerEvent: function (eventName) {
                this._events[eventName] = new Event(eventName);
            },

            /**
             * Dispatch an event that has been previously registered on the object
             *
             * @param {String} eventName
             * @param {*} eventArgs Any number of additional arguments to be passed to the callback function
             * @returns {undefined}
             */
            dispatchEvent: function (eventName) {
                var args = Array.prototype.slice.call(arguments, 1);
                var self = this;
                $.each(this._events[eventName].callbacks, function (index, callback) {
                    callback.apply(self, args);
                });
            },

            /**
             * Add an event listener to the object with a callback function
             * @param {String} eventName
             * @param {Function} callback
             * @returns {undefined}
             */
            on: function (eventName, callback) {
                this._events[eventName].registerCallback(callback);
            },

            /**
             * Removes the given event listener on the object
             *
             * @param {String} eventName
             * @param {Function} callback
             */
            off: function(eventName, callback) {
                var self = this;
                $.each(this._events[eventName].callbacks, function(index, activeCallback){
                    if (callback === activeCallback){
                        self._events[eventName].callbacks.splice(index, 1);
                    }
                });
            }
        });

        return EventDispatcher;
    });


//////////////////
// WEBPACK FOOTER
// ./~/fcse-events/eventDispatcher.js
// module id = 11
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23